import type { VideoJob } from '../services/local-video';
import { RENDER_PRESETS } from '../domain/render-preset';
import { videoJobSettings } from './video-job-diagnostics';

function timestamp(value?: string): string {
  if (!value || !Number.isFinite(Date.parse(value))) return 'Unavailable';
  return new Intl.DateTimeFormat('en-US', { dateStyle: 'medium', timeStyle: 'long' }).format(new Date(value));
}

export function VideoJobDetails({ job }: { job: VideoJob }) {
  const preset = RENDER_PRESETS.find(item => item.id === job.preset);
  const tracks = job.cinematicSequence?.cameraTracks;
  const settings = `data:application/json;charset=utf-8,${encodeURIComponent(JSON.stringify(videoJobSettings(job), null, 2))}`;
  return <details className="video-job-metadata">
    <summary>Export details</summary>
    <dl>
      <dt>Job ID</dt><dd><code>{job.id}</code></dd>
      <dt>Submitted</dt><dd>{timestamp(job.createdAt)}</dd>
      <dt>Last update</dt><dd>{timestamp(job.updatedAt)}</dd>
      <dt>Status / phase</dt><dd>{job.state} / {job.phase}</dd>
      <dt>Attempt</dt><dd>{job.attempts ?? 'Unavailable'}</dd>
      {job.failureCode && <><dt>Failure code</dt><dd><code>{job.failureCode}</code></dd></>}
      {preset && <><dt>Dimensions</dt><dd>{preset.width} × {preset.height}</dd></>}
      {job.frameProgress && <><dt>Captured frames</dt><dd>{job.frameProgress.captured.toLocaleString('en-US')} / {job.frameProgress.total.toLocaleString('en-US')}</dd></>}
      <dt>Composition / camera keys</dt><dd>{job.cinematicSequence?.waypoints.length ?? 0} / {tracks ? tracks.rotation.length + tracks.tilt.length + (tracks.roll?.length ?? 0) + tracks.altitude.length + tracks.lens.length : 0}</dd>
      {tracks && <><dt>Target Lock</dt><dd>{tracks.targetLock ? 'On' : 'Off'}</dd></>}
    </dl>
    <a download={`overland-traces-${job.id}-settings.json`} href={settings}>Download export settings</a>
  </details>;
}
